import { render, staticRenderFns } from "./setVechicleDeptDrawer.vue?vue&type=template&id=e38b6964&scoped=true"
import script from "./setVechicleDeptDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./setVechicleDeptDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./setVechicleDeptDrawer.vue?vue&type=style&index=0&id=e38b6964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b6964",
  null
  
)

export default component.exports